module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit_client_info":"Client Information","validate":"Validate"},"fr":{"edit_client_info":"Informations Client","validate":"Valider"},"de":{"edit_client_info":"Kundeninformation","validate":"Bestätigen"}}')
  delete Component.options._Ctor
}
